import React from "react";

const PlaceholderPage = ({ title, subtitle }) => (
  <div className="gwContentGrid">
    <section className="gwFormStack">
      <div className="gwPageHeader">
        <div>
          <div className="gwPageTitle">{title}</div>
          <div className="gwPageSubtitle">{subtitle}</div>
        </div>
      </div>
      <div className="gwEmptyState">
        <div className="gwEmptyTitle">Coming soon</div>
        <div className="gwEmptyBody">
          This view is scaffolded for MVP layout testing.
        </div>
      </div>
    </section>
  </div>
);

export default PlaceholderPage;
